module.exports = __webpack_public_path__ + "img/station_disable@2x.5fd03258.png";